export const useReducedMotion = () => {
  const reducedMotionPreference = usePreferredReducedMotion()

  return computed(() => reducedMotionPreference.value === 'reduce')
}
